var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-title"},[_c(_vm.h_tag,{tag:"component"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }